import React from "react";

export const Tree = ({ className }) => (
  <svg viewBox="0 0 80 110" className={className} aria-hidden="true">
    <path d="M40 4 62 38H52l18 28H56l18 28H6l18-28H10l18-28H18z" fill="#1f7a46" />
    <path d="M40 4 62 38H52l18 28H56l18 28H40z" fill="#16653a" />
    <rect x="34" y="94" width="12" height="14" rx="2" fill="#7a4a2a" />
    <circle cx="30" cy="52" r="3.5" fill="#f5c46b" /><circle cx="50" cy="70" r="3.5" fill="#e23b4e" /><circle cx="26" cy="80" r="3.5" fill="#fff" /><circle cx="46" cy="40" r="3" fill="#fff" /><circle cx="58" cy="84" r="3.5" fill="#f5c46b" />
    <path d="m40 0 3 6 6 .8-4.5 4 1 6.2L40 14l-5.5 3 1-6.2-4.5-4 6-.8z" fill="#f5c46b" />
  </svg>
);

export const Bauble = ({ color = "#e23b4e", className }) => (
  <svg viewBox="0 0 40 52" className={className} aria-hidden="true">
    <rect x="15" y="4" width="10" height="7" rx="2" fill="#d9b25a" />
    <circle cx="20" cy="31" r="18" fill={color} />
    <ellipse cx="13" cy="24" rx="5" ry="7" fill="#fff" opacity=".35" />
    <path d="M4 31c8 5 24 5 32 0" stroke="#fff" strokeOpacity=".5" strokeWidth="2" fill="none" />
  </svg>
);

export const GiftBox = ({ className, color = "#e23b4e" }) => (
  <svg viewBox="0 0 60 60" className={className} aria-hidden="true">
    <rect x="6" y="22" width="48" height="34" rx="4" fill={color} />
    <rect x="3" y="14" width="54" height="12" rx="3" fill={color} />
    <rect x="26" y="14" width="8" height="42" fill="#f5c46b" />
    <path d="M30 14c-6-12-20-10-14-2 3 3 14 2 14 2zm0 0c6-12 20-10 14-2-3 3-14 2-14 2z" fill="#f5c46b" />
  </svg>
);

export const BigHeart = ({ className, color = "#e11d48" }) => (
  <svg viewBox="0 0 48 44" className={className} aria-hidden="true">
    <path d="M24 42S2 28 2 14C2 7 7 2 13.5 2 18 2 22 5 24 9c2-4 6-7 10.5-7C41 2 46 7 46 14c0 14-22 28-22 28z" fill={color} />
    <ellipse cx="14" cy="13" rx="5" ry="3.5" fill="#fff" opacity=".35" />
  </svg>
);

export const Flower = ({ className, color = "#c084fc" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    {[0, 72, 144, 216, 288].map((r) => <ellipse key={r} cx="24" cy="12" rx="8" ry="11" fill={color} transform={`rotate(${r} 24 24)`} />)}
    <circle cx="24" cy="24" r="7" fill="#fcd34d" />
  </svg>
);

const MiniPumpkin = ({ className }) => (
  <svg viewBox="0 0 60 52" className={className} aria-hidden="true">
    <path d="M29 8c0-4 3-7 7-7" stroke="#3f6212" strokeWidth="4" fill="none" strokeLinecap="round" />
    {[12, 24, 36].map((x) => <ellipse key={x} cx={x + 6} cy="30" rx="14" ry="20" fill={x === 24 ? "#ff8a1f" : "#e8590c"} />)}
    <path d="M18 24l6 5-8 2zM42 24l-6 5 8 2zM17 37q13 9 26 0l-4 2-3-3-3 4-3-4-3 4-3-3z" fill="#fff3b0" />
  </svg>
);

export const Ghost = ({ className }) => (
  <svg viewBox="0 0 50 60" className={className} aria-hidden="true">
    <path d="M25 2C12 2 4 12 4 26v30l7-6 7 6 7-6 7 6 7-6 7 6V26C46 12 38 2 25 2z" fill="#fff" opacity=".95" />
    <ellipse cx="18" cy="24" rx="3.5" ry="5" fill="#1a0b2e" /><ellipse cx="32" cy="24" rx="3.5" ry="5" fill="#1a0b2e" /><ellipse cx="25" cy="36" rx="4" ry="3" fill="#1a0b2e" />
  </svg>
);

const MiniSpider = ({ className }) => (
  <svg viewBox="0 0 40 30" className={className} aria-hidden="true"><g stroke="#111" strokeWidth="2.2" fill="none">{[-1, 1].map((d) => [4, 10, 16].map((y) => <path key={`${d}${y}`} d={`M20 15Q${20 + d * 12} ${y - 6} ${20 + d * 19} ${y + 2}`} />))}</g><ellipse cx="20" cy="15" rx="7" ry="8" fill="#111" /><circle cx="17.5" cy="13" r="1.4" fill="#ff8a1f" /><circle cx="22.5" cy="13" r="1.4" fill="#ff8a1f" /></svg>
);

const StarArt = ({ className, color = "#f5c46b" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true"><path d="M20 2l5 12 13 1-10 8 3 13-11-7-11 7 3-13-10-8 13-1z" fill={color} /></svg>
);

const EggArt = ({ className, color = "#fde68a" }) => (
  <svg viewBox="0 0 40 50" className={className} aria-hidden="true"><ellipse cx="20" cy="27" rx="17" ry="22" fill={color} /><path d="M4 24q8-6 16 0t16 0" stroke="#fff" strokeWidth="3" fill="none" opacity=".8" /></svg>
);

const BalloonArt = ({ className, color = "#0073FF" }) => (
  <svg viewBox="0 0 40 56" className={className} aria-hidden="true"><ellipse cx="20" cy="20" rx="17" ry="20" fill={color} stroke={color === "#ffffff" ? "#cfe3ff" : "none"} /><ellipse cx="14" cy="13" rx="4" ry="6" fill="#fff" opacity=".45" /><path d="M20 40l-3 5h6z" fill={color} /></svg>
);

const Mandarin = ({ className }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true"><circle cx="20" cy="22" r="17" fill="#f97316" /><circle cx="14" cy="16" r="4" fill="#fdba74" opacity=".7" /><path d="M20 6q6-6 12-2-6 4-12 2z" fill="#16a34a" /></svg>
);

const ITEM = { bauble: Bauble, heart: BigHeart, flower: Flower, pumpkin: MiniPumpkin, spider: MiniSpider, star: StarArt, egg: EggArt, balloon: BalloonArt, mandarin: Mandarin, ghost: Ghost };
const SIZE = { bauble: "h-9 w-7", heart: "h-7 w-7", flower: "h-8 w-8", pumpkin: "h-9 w-10", spider: "h-7 w-9", star: "h-7 w-7", egg: "h-9 w-7", balloon: "h-12 w-9", mandarin: "h-8 w-8", ghost: "h-10 w-8" };

export const Bolt = ({ className }) => (
  <svg viewBox="0 0 40 60" className={className} aria-hidden="true"><path d="M24 0 2 34h14l-4 26 26-36H24z" fill="#e8ff3a" /></svg>
);

export const Tag = ({ className, label = "%" }) => (
  <svg viewBox="0 0 60 40" className={className} aria-hidden="true">
    <path d="M14 2h42a2 2 0 0 1 2 2v32a2 2 0 0 1-2 2H14L2 20z" fill="#e5321b" />
    <circle cx="14" cy="20" r="3" fill="#fff" />
    <text x="36" y="27" textAnchor="middle" fontSize="18" fontWeight="800" fill="#fff">{label}</text>
  </svg>
);

const HANG = {
  noel: [["#e23b4e", 40], ["#f5c46b", 70], ["#ffffff", 30], ["#2e8b57", 60], ["#e23b4e", 45]],
  "saint-valentin": [["#e11d48", 50], ["#fb7185", 30], ["#e11d48", 65], ["#fda4af", 40]],
  "fete-des-meres": [["#c084fc", 40], ["#f0abfc", 60], ["#a855f7", 35]],
  halloween: [["", 50, "pumpkin"], ["", 90, "spider"], ["", 30, "ghost"], ["", 70, "spider"], ["", 45, "pumpkin"]],
  "nouvel-an": [["#f5c46b", 40, "star"], ["#ffffff", 70, "star"], ["#f5c46b", 30, "star"], ["#e5c07b", 55, "star"]],
  "saint-sylvestre": [["#f5c46b", 50, "star"], ["#ffffff", 30, "star"], ["#5AC8FA", 65, "star"], ["#f5c46b", 40, "star"]],
  anniversaire: [["#0073FF", 40, "balloon"], ["#5AC8FA", 70, "balloon"], ["#ffffff", 30, "balloon"], ["#0073FF", 55, "balloon"]],
  carnaval: [["#c026d3", 40, "star"], ["#f59e0b", 65, "star"], ["#0ea5e9", 30, "star"], ["#22c55e", 55, "star"]],
  paques: [["#fde68a", 40, "egg"], ["#bbf7d0", 65, "egg"], ["#fbcfe8", 30, "egg"], ["#bfdbfe", 50, "egg"]],
  "saint-nicolas": [["#f5c46b", 45, "star"], ["", 70, "mandarin"], ["#ffffff", 30, "star"], ["", 55, "mandarin"]],
  "fete-des-peres": [["#7cc4ff", 45, "star"], ["#f5c46b", 70, "star"], ["#7cc4ff", 30, "star"]],
};
const DEF_ITEM = { noel: "bauble", "saint-valentin": "heart" };

export function Garland({ seasonKey }) {
  const list = HANG[seasonKey];
  if (!list) return null;
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 z-[3] hidden justify-end gap-8 pr-[30%] md:flex" aria-hidden="true" data-testid="mq-garland">
      {list.map(([c, h], k) => (
        <div key={k} className="mq-swing flex flex-col items-center" style={{ animationDelay: `${k * 0.4}s` }}>
          <div className="w-px bg-current opacity-40" style={{ height: h }} />
          {(() => { const t = list[k][2] || DEF_ITEM[seasonKey] || "flower"; const I = ITEM[t]; return <I color={c || undefined} className={SIZE[t]} />; })()}
        </div>
      ))}
    </div>
  );
}

export function Ground({ seasonKey, pos = "right-[44%]" }) {
  const G = {
    noel: <><Tree className="h-28 w-20" /><Tree className="-ml-6 h-20 w-14" /><GiftBox className="-ml-2 h-12 w-12" /><GiftBox color="#2e8b57" className="-ml-3 h-9 w-9" /></>,
    "saint-valentin": <><BigHeart className="h-16 w-16" /><BigHeart color="#fb7185" className="-ml-4 h-10 w-10" /></>,
    "fete-des-meres": <><Flower className="h-14 w-14" /><Flower color="#f0abfc" className="-ml-3 h-10 w-10" /><GiftBox color="#a855f7" className="h-11 w-11" /></>,
    "fete-des-peres": <><GiftBox color="#1e4fa3" className="h-14 w-14" /><GiftBox color="#7cc4ff" className="-ml-3 h-10 w-10" /></>,
    "black-friday": <><Bolt className="h-16 w-10" /><Bolt className="-ml-2 h-10 w-7" /></>,
    soldes: <><Tag label="-%" className="h-12 w-20 -rotate-12" /><Tag label="%" className="-ml-4 h-9 w-14 rotate-6" /></>,
    halloween: <><MiniPumpkin className="h-16 w-20" /><Ghost className="mq-float -ml-2 mb-10 h-14 w-12" /><MiniPumpkin className="-ml-3 h-10 w-12" /><Ghost className="mq-float mb-16 ml-2 h-9 w-8 opacity-80" /></>,
    paques: <><EggArt className="h-14 w-11" /><EggArt color="#bbf7d0" className="-ml-3 h-10 w-8" /><EggArt color="#fbcfe8" className="-ml-2 h-12 w-9" /></>,
    "saint-nicolas": <><GiftBox className="h-14 w-14" /><Mandarin className="-ml-2 h-9 w-9" /><Mandarin className="-ml-3 h-7 w-7" /><GiftBox color="#f5c46b" className="-ml-1 h-10 w-10" /></>,
    "nouvel-an": <><GiftBox color="#f5c46b" className="h-12 w-12" /><StarArt className="mq-float -ml-1 mb-8 h-8 w-8" /></>,
    "saint-sylvestre": <><StarArt className="mq-float mb-6 h-9 w-9" /><StarArt color="#ffffff" className="mq-float -ml-1 mb-12 h-6 w-6" /></>,
    anniversaire: <><GiftBox color="#0073FF" className="h-14 w-14" /><GiftBox color="#5AC8FA" className="-ml-3 h-10 w-10" /></>,
    carnaval: <><StarArt color="#c026d3" className="mq-float mb-4 h-9 w-9" /><StarArt color="#f59e0b" className="mq-float -ml-1 mb-10 h-7 w-7" /><StarArt color="#0ea5e9" className="mq-float mb-2 h-6 w-6" /></>,
    "octobre-rose": <><BigHeart color="#f472b6" className="h-14 w-14" /><Flower color="#f9a8d4" className="-ml-3 h-11 w-11" /><BigHeart color="#d63a7a" className="-ml-2 h-9 w-9" /></>,
    "fete-nationale": <><StarArt color="#fdda24" className="mq-float mb-6 h-9 w-9" /><StarArt color="#ef3340" className="mq-float -ml-1 mb-12 h-7 w-7" /><StarArt color="#ffffff" className="mq-float mb-3 h-6 w-6" /></>,
  }[seasonKey];
  if (!G) return null;
  return <div className={`pointer-events-none absolute bottom-0 ${pos} z-[3] hidden items-end md:flex`} aria-hidden="true" data-testid="mq-ground">{G}</div>;
}
